export default __webpack_public_path__ + "static/media/operation.60cd3336.png";